import { useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ActivitiesActions, EntityDetailActions } from 'actions';
import { ACTIVITIES } from 'constants/Entities';

import { getEnableTimeLine } from '../utils/timeline';

export const selectActivitiesDetailState = (state, widgetActivity) => {
    const entityList = state?.entityList;

    const tabsObjEntris = Object.entries(state.entityDetail.tabs);
    const primaryTab = tabsObjEntris.find(([key, value]) => value.primary)?.[0];

    const active = entityList?.active;
    const activityList = entityList?.[active] || null;
    const activities = activityList?.data || [];
    const entityDetail = state?.entityDetail || null;
    const activeDetailKey = tabsObjEntris.length > 1 ? primaryTab : entityDetail?.active;

    let activeDetail = entityDetail?.[activeDetailKey] || null;

    if (widgetActivity) {
        activeDetail = entityDetail?.[`${ACTIVITIES.entity}-${widgetActivity.Id}`] || null;
    }
    const loading = activeDetail?.loading || false;
    let activity = activeDetail?.data && activeDetail?.data?.Id ? activeDetail.data : null;

    const userData = state.config.userData || null;
    const extraFields = state.activities?.extraFields?.data || [];
    const tab = activeDetail?.extra?.tab || '';
    const initialTabItem = parseInt(activeDetail?.extra?.tabItemId, 10) || -1;
    const tabsNames = state.activities?.tabsNames || [];
    const matchingName = state?.entityFilters?.activities?.filters?.matchingName?.value;

    if (widgetActivity) {
        activity = widgetActivity;
        activity.TimeLineUnreadMessages = activeDetail
            ? activeDetail.data.TimeLineUnreadMessages || 0
            : activity.TimeLineUnreadMessages;
        activity.timeLineMessages = activeDetail
            ? activeDetail.data?.timeLineMessages || 0
            : activity.timeLineMessages;
    }

    const files = activity?.Id ? state.activities.files?.[activity.Id] : {};
    const filesList = files?.list || [];
    const isLoadingFilesList = files?.isLoading || false;

    const showActionsAndMenu = Object.entries(entityDetail?.tabs).length === 1 && !widgetActivity;

    return {
        activity,
        activities,
        allowEmailAttachments: userData?.allowEmailAttachments || false,
        canCreateDocuments: state?.config?.permission?.crud_permission?.DOCUMENT?.create,
        canDeleteImages: state.config.permission.delete_activity_image || false,
        canEditActivity:
            !!state?.config?.permission?.crud_permission?.[ACTIVITIES.permission]?.update,
        canUploadImages: state.config.permission.upload_activity_image || false,
        canViewAllGeopositionedActivities:
            !!state?.config?.permission?.gest_visualizar_posicionamiento,
        enableTimeLine: getEnableTimeLine(),
        extraFields,
        extraFieldsLoading: state.activities?.extraFields?.loading || false,
        filesList,
        initialTabItem,
        isLoadingFilesList,
        loading,
        matchingName,
        showActionsAndMenu,
        tab,
        tabsNames,
    };
};

const useActivitiesDetailState = (widgetActivity) => {
    const state = useSelector(
        (reduxState) => selectActivitiesDetailState(reduxState, widgetActivity),
        shallowEqual,
    );

    const dispatch = useDispatch();

    const dispatchProps = useMemo(() => {
        const { getActivityFiles, removeActivityFile, updateTabsNames } = bindActionCreators(
            ActivitiesActions,
            dispatch,
        );
        const { updateDetailExtra, updateDetailFields: updateEntityDetail } = bindActionCreators(
            EntityDetailActions,
            dispatch,
        );

        return {
            getActivityFiles,
            removeActivityFile,
            updateDetailExtra,
            updateEntityDetail,
            updateTabsNames,
        };
    }, [dispatch]);

    return { ...state, ...dispatchProps };
};

export default useActivitiesDetailState;
